import React from 'react';
import Text from '../Text';
import { Card, Input } from 'antd';
import Link from '../Link';
import Tag from '../Tag';
import Badge from '../Badge';
import Avatar from '../Avatar/Avatar';
import { IconChat } from '../Icons';
import { StatusType, TagTypes } from '../../types';
import isEmpty from 'lodash/isEmpty';
import './StudentAttendanceCard.less';

export type StudentAttendanceCardProps = {
  name?: string;
  image?: string;
  email: string;
  title?: string;
  id?: string;
  attendanceData?: {
    attend?: true;
    excused?: false;
    trial?: false;
    score?: number;
    attendanceNote?: string;
  };
  onBlur?: any;
  openMessages?: () => void;
};

const StudentAttendanceCard: React.FC<StudentAttendanceCardProps> = ({
  children,
  title,
  onBlur,
  openMessages,
  ...props
}) => {
  const { image, name, email, id, attendanceData = {} } = props;
  const {
    attend = false,
    excused = false,
    trial = false,
    score = 0,
  } = attendanceData;

  const getStatus = () => {
    if (isEmpty(attendanceData)) {
      return {};
    }
    if (attend) {
      if (trial) {
        return { status: 'Trial', color: StatusType.WARNING };
      }
      return { status: 'Present', color: StatusType.SUCCESS };
    }
    if (excused) {
      return { status: 'Excused', color: StatusType.DEFAULT };
    }
    return { status: 'Absent', color: StatusType.ERROR };
  };

  const content = (
    <>
      <div className="t-card-text-wrapper">
        <Link
          href={`/students/${id}`}
          title={
            <Text rows={1} level={4}>
              {name}
            </Text>
          }
        />
        <Text textColor="dark-50" rows={1} level={4}>
          {email}
        </Text>
      </div>
      <div className="t-card-note-container">
        {!isEmpty(attendanceData) && (
          <Input
            className="t-card-note-input"
            onBlur={onBlur}
            placeholder="Add a note"
            bordered={false}
            {...props}
          />
        )}
        <div className="t-card-grade-tag">
          {!!openMessages && (
            <IconChat onClick={openMessages} fill="red" size="md" />
          )}
          <Tag type={TagTypes.NEUTRAL}>{score || '-'}</Tag>
        </div>
      </div>
    </>
  );

  const { status, color } = getStatus();

  return (
    <div className="t-card-container">
      <Card
        className="t-card"
        bodyStyle={{ padding: '16px' }}
        extra={<Badge type="reverse" status={color} statusText={status} />}
        title={<Avatar src={image} name={name} size="md" />}
      >
        <Card.Meta description={content} />
      </Card>
    </div>
  );
};

export default StudentAttendanceCard;
